import React from "react";
import { Route } from "react-router-dom";
import NetworkUsers from "./pages/NetworkUsers";
import Debates from "./pages/Debates";
import Analytics from "./pages/Analytics";
import Collections from "./pages/Collections";
import NewCollection from "./pages/NewCollection";
import Forms from "./pages/Forms";
import NewForm from "./pages/NewForm";
import Audience from "./pages/Audience";
import Segments from "./pages/Segments";
import NewSegment from "./pages/NewSegment";
import Networks from "./pages/Networks";
import AddNetwork from "./pages/AddNetwork";
import EditNetwork from "./pages/EditNetwork";
import Advertising from "./pages/Advertising";
import StartDebate from "./pages/StartDebate";
import EditDebate from "./pages/EditDebate";
import DraftDebate from "./pages/DraftDebate";
import EditProfile from "./pages/EditProfile";
import Groups from "./pages/Groups";
import GroupNetworks from "./pages/GroupNetworks";
import GroupNetworkUsers from "./pages/GroupNetworkUsers";
import GroupUsers from "./pages/GroupUsers";
import { connect } from "react-redux";
import GroupAdvertising from "./pages/GroupAdvertising";
import Moderation from "./pages/Moderation";
import ReportsOverview from "./pages/reports/ReportsOverview";
import ReportsPerformance from "./pages/reports/ReportsPerformance";
import ReportsAccounting from "./pages/reports/ReportsAccounting";
import AdvertisingAds from "./pages/advertising/AdvertisingAds";
import Campaigns from "./pages/campaign/List";
import AddEditCampaign from "./pages/campaign/AddEdit";
import GlobalSettings from "./pages/GlobalSettings";
import ReportsAiUsage from "./pages/reports/ReportsAiUsage";
class Section extends React.Component {
  render() {
    const { selNetworkId, loggedInUser } = this.props;
    const { roles } = loggedInUser;
    const networkRoles = roles.filter(
      ({ roleUser }) => roleUser.clientId === parseInt(selNetworkId)
    );
    const isSuperAdmin = !!roles.find(({ name }) => name === "SUPERADMIN");
    const isAdmin = !!networkRoles.find(({ name }) => name === "ADMIN");
    const isModerator = !!networkRoles.find(({ name }) => name === "MODERATOR");
    const isEditor =
      !isAdmin && !!networkRoles.find(({ name }) => name === "EDITOR");

    return (
      <>
        {isSuperAdmin || isAdmin || isEditor ? (
          <>
            <Route exact path="/" render={(props) => <Debates {...props} />} />
            <Route exact path="/forms" component={Forms} />
            <Route exact path="/forms/:id" component={NewForm} />
            <Route exact path="/sequences" component={Collections} />
            <Route exact path="/sequences/:id" component={NewCollection} />
            
            <Route
              exact
              path="/quizzes"
              render={(props) => <Debates {...props} type="quiz" />}
            />
            <Route exact path="/debates/start-debate" component={StartDebate} />
            <Route exact path="/debates/draft/:id" component={DraftDebate} />
            <Route
              exact
              path="/debates/debate/:id"
              render={(props) => <EditDebate {...props} />}
            />
            <Route exact path="/campaigns" component={Campaigns} />
            <Route path="/campaigns/upsert/:id" component={AddEditCampaign} />
          </>
        ) : null}

        {isSuperAdmin || isAdmin || isModerator ? (
          <Route exact path="/moderation" component={Moderation} />
        ) : null}

        {isSuperAdmin || isAdmin ? (
          <>
            <Route exact path="/analytics" component={Analytics} />
            <Route exact path="/audience" component={Audience} />
            <Route exact path="/audience/segments" component={Segments} />
            <Route exact path="/audience/segments/:id" component={NewSegment} />
            <Route exact path="/advertising" component={Advertising} />
            <Route exact path="/advertising/ads" component={AdvertisingAds} />
            <Route exact path="/networks" component={Networks} />
            <Route exact path="/networks/add-network" component={AddNetwork} />
            <Route exact path="/global-settings" component={GlobalSettings} />
            <Route
              exact
              path="/networks/edit-network/:id"
              render={(props) => <EditNetwork {...props} />}
            />
            <Route exact path="/network/users" component={NetworkUsers} />
            <Route
              exact
              path="/network/settings"
              render={(props) => <EditNetwork {...props} tab="network" />}
            />
            <Route
              exact
              path="/network/integration"
              render={(props) => <EditNetwork {...props} tab="integration" />}
            />
            <Route
              exact
              path="/network/categories"
              render={(props) => <EditNetwork {...props} tab="categories" />}
            />
            <Route
              exact
              path="/network/admin"
              render={(props) => <EditNetwork {...props} tab="admin" />}
            />
            <Route exact path="/profile/edit" component={EditProfile} />
            <Route exact path="/groups" component={Groups} />
            <Route
              exact
              path="/groups/:groupSlug/networks/"
              component={GroupNetworks}
            />
            <Route
              exact
              path="/groups/:groupSlug/networks/:clientId/users"
              component={GroupNetworkUsers}
            />
            <Route
              exact
              path="/groups/:groupSlug/users"
              component={GroupUsers}
            />
            <Route
              exact
              path="/groups/:groupSlug/analytics/"
              component={Analytics}
            />
            <Route
              exact
              path="/groups/:groupSlug/advertising/"
              component={GroupAdvertising}
            />

            <Route exact path="/reports" component={ReportsOverview} />
            <Route
              exact
              path="/reports/performance"
              component={ReportsPerformance}
            />
            <Route
              exact
              path="/reports/ai-usage"
              component={ReportsAiUsage}
            />
          </>
        ) : null}
        {isSuperAdmin ? (
          <Route
            exact
            path="/reports/accounting"
            component={ReportsAccounting}
          />
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  loggedInUser: state.login.user,
  selNetworkId: state.networks.selNetworkId,
});

export default connect(mapStateToProps, {})(Section);
